import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Plus, Package, Tags, FileText, Settings } from "lucide-react";
import { useNavigate } from "react-router-dom";

const QuickActions = () => {
  const navigate = useNavigate();

  const actions = [
    {
      name: "Add Product",
      icon: Plus,
      color: "text-green-600",
      bgColor: "bg-green-100",
      onClick: () => navigate("/vendor/products/add")
    },
    {
      name: "Manage Inventory",
      icon: Package,
      color: "text-blue-600",
      bgColor: "bg-blue-100",
      onClick: () => navigate("/vendor/products")
    },
    {
      name: "Update Prices",
      icon: Tags,
      color: "text-purple-600",
      bgColor: "bg-purple-100",
      onClick: () => navigate("/vendor/products")
    },
    {
      name: "View Orders",
      icon: FileText,
      color: "text-orange-600",
      bgColor: "bg-orange-100",
      onClick: () => navigate("/vendor/orders")
    }
  ];

  return (
    <Card className="p-6 hover:shadow-lg transition-all duration-200">
      <div className="flex items-center justify-between mb-6">
        <div className="space-y-1">
          <h2 className="text-lg font-semibold flex items-center gap-2">
            <Settings className="h-5 w-5 text-[#9b87f5]" />
            Quick Actions
          </h2>
          <p className="text-sm text-muted-foreground">Common tasks and shortcuts</p>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-4">
        {actions.map((action) => (
          <Button
            key={action.name}
            variant="outline"
            className="h-auto p-4 flex flex-col items-center gap-2 hover:bg-gray-50"
            onClick={action.onClick}
          >
            <div className={`p-2 rounded-lg ${action.bgColor}`}>
              <action.icon className={`h-5 w-5 ${action.color}`} />
            </div>
            <span className="text-sm font-medium">{action.name}</span>
          </Button>
        ))}
      </div>
    </Card>
  );
};

export default QuickActions;